// extracted by mini-css-extract-plugin
export default {"orDivider":"OrDivider--orDivider--X6SS0","or":"OrDivider--or--rdcMJ","light":"OrDivider--light--BPhFE","line":"OrDivider--line--LX6dD"};